"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classnames = require("classnames");
class NavmenuItem extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.clickHandler = (event) => {
            const { onClick, itemKey } = this.props;
            onClick(event, itemKey);
        };
    }
    render() {
        const { className, isActive, children, notificationCount, href } = this.props;
        const classNames = classnames('vf-navmenu-item vf-upper vf-font-semi-bold', className);
        return (React.createElement("li", { className: classNames },
            React.createElement("a", { href: href, onClick: this.clickHandler, className: isActive ? 'active' : '' },
                children,
                notificationCount &&
                    React.createElement("span", { className: 'vf-badge vf-pull-right' }, notificationCount))));
    }
}
exports.default = NavmenuItem;
